import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useDialog } from '../../shared/context';
import { Button, Box } from '@mui/material';
import ApproveResgistre from '../layout/approverRegistre/ApproveResgistre';
import ApproveConsult from '../layout/approverRegistre/ApproveConsult';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ApproveDialog = ({ handleCancel }) => {
  const approveDialog = useDialog('approveDialog');
  const [getComponent, setComponent] = useState('consult');
  const [getTitle, setTitle] = useState('Consultar Aprovadores');

  const handleChangeComponent = (title, component) => {
    setComponent(component);
    setTitle(title);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  };

  return (
    <Dialog
      open={approveDialog.isDialogOpen()}
      TransitionComponent={Transition}
      keepMounted
      onClose={approveDialog.closeDialog}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle sx={{ fontSize: '2em' }}>{getTitle}</DialogTitle>
      <DialogContent>
        <Box>
          {getComponent === 'consult' ? (
            <ApproveConsult handleChangeComponent={handleChangeComponent} />
          ) : (
            <ApproveResgistre
              handleFormSubmit={handleFormSubmit}
              handleChangeComponent={handleChangeComponent}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveDialog;
